import React from "react";
import "bootstrap/js/dist/carousel";
import "./EstileVideosIne.css";

const VideosINE = () => {
  const videoGroups = [
    [
      {
        id: "jvOZFERXuiM",
        title: "Cápsula en Náhuatl",
        duracion: "03:12",
        url: "https://youtu.be/jvOZFERXuiM"
      },
      {
        id: "EEHZkyv-sTE",
        title: "Cápsula en Yuhmú (variante del Otomí)",
        duracion: "02:45",
        url: "https://youtu.be/EEHZkyv-sTE",
        isIframe: true
      },
      {
        id: "SvfEVaA6jF8",
        title: "Votación de Personas con Discapacidad",
        duracion: "04:20",
        url: "https://youtu.be/SvfEVaA6jF8",
        bordeBlanco: true
      }
    ],
    [
      {
        id: "7sg3kvUYxRY",
        title: "Voto de Personas con Discapacidad Trans, No Binarias",
        duracion: "03:45",
        url: "https://youtu.be/7sg3kvUYxRY"
      },
      {
        id: "dizDZWMNJxE",
        title: "Proceso de Votación de las Personas con Discapacidad",
        duracion: "02:50",
        url: "https://youtu.be/dizDZWMNJxE"
      },
      {
        id: "r9X_4Jlju3E",
        title: "Consulta Infantil y Juvenil 2024",
        duracion: "04:10",
        url: "https://youtu.be/r9X_4Jlju3E"
      }
    ]
  ];

  return (
    <div className="estileVideosIne-slider-wrapper">
      <div
        id="carouselVideosINE"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {videoGroups.map((group, groupIndex) => (
            <div
              className={`carousel-item ${groupIndex === 0 ? "active" : ""}`}
              key={`group-${groupIndex}`}
            >
              <div className="row g-4 justify-content-center">
                {group.map((video, videoIndex) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 estileVideosIne-col-item"
                    key={`video-${groupIndex}-${videoIndex}`}
                  >
                    <a
                      href={video.url}
                      target="_blank"
                      rel="noreferrer"
                      className="estileVideosIne-card"
                      title={video.title}
                    >
                      {/* Contenedor de la imagen / miniatura (relación 16:9) */}
                      <div className="estileVideosIne-thumb-container">
                        <img
                          src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                          alt={video.title}
                          className="estileVideosIne-thumb"
                          loading="lazy"
                          decoding="async"
                          width="480"
                          height="360"
                        />

                        {/* Overlay sutil al pasar el mouse */}
                        <div
                          className="estileVideosIne-overlay"
                          aria-hidden="true"
                        ></div>

                        {/* Badge de duración arriba a la derecha */}
                        <div className="estileVideosIne-duracion">
                          {video.duracion}
                        </div>

                        {/* Zona del título y subtítulo superpuesta en la parte inferior */}
                        <div className="estileVideosIne-info">
                          <div className="estileVideosIne-info-left">
                            <span
                              className="estileVideosIne-linea"
                              aria-hidden="true"
                            ></span>
                            <div className="estileVideosIne-textos">
                              <h5 className="estileVideosIne-titulo">
                                <span>{video.title}</span>
                              </h5>
                            </div>
                          </div>

                          {/* Botón circular con flecha ">" */}
                          <div
                            className="estileVideosIne-boton"
                            aria-hidden="true"
                          >
                            <svg
                              className="estileVideosIne-boton-flecha"
                              viewBox="0 0 24 24"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Flechas del slider restilizadas con la clase estileVideosIne-flecha */}
        <button
          className="carousel-control-prev estileVideosIne-flecha"
          type="button"
          data-bs-target="#carouselVideosINE"
          data-bs-slide="prev"
          aria-label="Anterior"
        >
          <svg className="estileVideosIne-flecha-svg" viewBox="0 0 24 24">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button
          className="carousel-control-next estileVideosIne-flecha"
          type="button"
          data-bs-target="#carouselVideosINE"
          data-bs-slide="next"
          aria-label="Siguiente"
        >
          <svg className="estileVideosIne-flecha-svg" viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default VideosINE;